//Product enquire 
    $('.btn-enquiry').click(function(e){
      $('#openModal').css('display','flex');
    });
    $(document).on('click','.close_order',function(){
      $(".modalDialog").css('display','none');
    });
    $(document).on('click','.close_enquire',function(){
      $(".modalDialog").css('display','none');
    });